export default __webpack_public_path__ + "static/media/phone.de99f119.png";